import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import * as globalState from '@/state';
import { CameraTargetProps, Number3 } from '@abyss/3d-viewer';
import { Zone } from '@/__generated__/graphql';

export const useZoneInitialCameraPose = () => {
  const setCameraTarget = useSetAtom(globalState.cameraTarget);

  const setZoneInitialCameraPose = useCallback(
    (zone: Zone) => {
      if (!zone) return;
      const { box } = zone;
      const boxCenter: Number3 = [
        (box.max.x + box.min.x) * 0.5,
        (box.max.y + box.min.y) * 0.5,
        (box.max.z + box.min.z) * 0.5,
      ];
      const maxSize = Math.max(box.max.x - box.min.x, box.max.y - box.min.y, box.max.z - box.min.z);

      const distance = 2.5 * maxSize;
      const cameraTarget: CameraTargetProps = {
        position: [boxCenter[0], boxCenter[1] + distance, boxCenter[2] + 0.3 * distance],
        lookAt: boxCenter,
      };
      setCameraTarget(cameraTarget);
    },
    [setCameraTarget]
  );

  return { setZoneInitialCameraPose };
};
